import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=b43dfc8a&scoped=true"
import script from "./Personal.vue?vue&type=script&lang=js"
export * from "./Personal.vue?vue&type=script&lang=js"
import style0 from "./Personal.vue?vue&type=style&index=0&id=b43dfc8a&prod&lang=css"
import style1 from "./Personal.vue?vue&type=style&index=1&id=b43dfc8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43dfc8a",
  null
  
)

export default component.exports